'use client';

import { motion, useInView, Variants } from 'motion/react';
import { ReactNode, useRef } from 'react';

import { DEFAULT_EASE } from '@natu/utils/consts';

interface AnimationWrapperProps {
  children: ReactNode;
  distance?: number;
  direction?: 'top-to-bottom' | 'bottom-to-top' | 'left-to-right' | 'right-to-left';
  fade?: boolean;
}

export const AnimationWrapper = ({
  distance = 0,
  direction,
  fade,
  children,
  ...rest
}: AnimationWrapperProps) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });

  const getXOffset = () => {
    if (direction === 'left-to-right') return -distance;
    if (direction === 'right-to-left') return distance;

    return 0;
  };

  const getYOffset = () => {
    if (direction === 'top-to-bottom') return -distance;
    if (direction === 'bottom-to-top') return distance;

    return 0;
  };

  const variants: Variants = {
    hidden: {
      opacity: fade ? 0 : 1,
      x: getXOffset(),
      y: getYOffset(),
    },
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
      transition: {
        ease: DEFAULT_EASE,
      },
    },
  };

  return (
    <div className="overflow-hidden" {...rest}>
      <motion.div
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
        variants={variants}
        ref={ref}
      >
        {children}
      </motion.div>
    </div>
  );
};
